<template>
  <div :class="$mq">
    <template v-if="showNav">
      <Header :title="title" @toggleMenu="toggleMenu" :back="back"></Header>
      <Menu v-if="showMenu" @close="closeMenu"></Menu>

      <div v-if="showPwaBanner" class="banner">
        <span class="message">{{ $t("miclive.ui.pwa_msg") }}</span>
        <div class="button" @click="install()">
          {{ $t("miclive.ui.install") }}
        </div>
        <div class="cancel" @click="dismiss()"></div>
      </div>

      <template v-if="showiOS">
        <div class="popup">
          <div class="message" v-html="$t('miclive.ui.pwa_msg_ios')"></div>
          <!-- <img class="img" src="img/pwa_ios.gif" /> -->
          <div class="img"></div>
          <div class="button" @click="closePopup()">
            {{ $t("miclive.ui.pwa_close") }}
          </div>
        </div>
        <div class="overlay-popup" @click="closePopup()"></div>
      </template>

      <section id="container">
        <router-view />
      </section>
      <Footer></Footer>
    </template>
    <template v-else>
      <section id="container">
        <router-view />
      </section>
    </template>
  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import Menu from "@/components/layout/Menu";
import Footer from "@/components/layout/Footer";

import { Api } from "@/core/api.js";
import i18n from "@/plugins/i18n";
const api = new Api();

export default {
  components: { Header, Menu, Footer },
  data() {
    return {
      title: "Inicio",
      showMenu: false,
      back: false,
      deferredPrompt: null,
      showiOS: false,
      showPwaBanner: false,
      showNav: true
      //   deferredPrompt: true
    };
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    },
    async dismiss() {
      this.deferredPrompt = null;
      this.showPwaBanner = false;
    },
    async install() {
      if (iOS()) {
        this.showiOS = true;
        this.showPwaBanner = false;
      } else {
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt();
        }
      }
    },
    closePopup() {
      this.showiOS = false;
    }
  },
  created() {
    var self = this;

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("service-worker.js")
        .then(reg => {
          console.log("Registration succesful, scope: " + reg.scope);

          if (!window.matchMedia("(display-mode: standalone)").matches) {
            // PWA is not installed
            if (iOS()) {
              self.showPwaBanner = false;
            } else {
              window.addEventListener("beforeinstallprompt", e => {
                e.preventDefault();
                self.deferredPrompt = e;
                self.showPwaBanner = true;
                console.log("beforeinstallprompt");
              });
              window.addEventListener("appinstalled", () => {
                console.log("appinstalled");
                self.deferredPrompt = null;
                self.showPwaBanner = false;
              });
            }
          } else {
            this.showPwaBanner = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }

    if (iOS()) {
      self.showPwaBanner = true;
    }

    api.get("miclive/init?lang=" + moment.locale()).then(function(data) {
      self.token = data.data.token;
      localStorage.setItem("token", self.token);

      self.$store.dispatch("facilities/loadList").then(function() {});
      self.$store.dispatch("competition/loadSkeleton").then(function() {});
      self.$store.dispatch("competition/loadClubs").then(function() {});
      self.$store.commit("setSponsors", data.data.sponsors);
      self.$store.commit("setLinks", data.data.links);
      if (data.data.home == "/upcoming") {
        self.showNav = false;
        self.$router.push({
          name: "upcoming"
        });
      }
    });
  },
  watch: {
    "$route.name": {
      handler: function(newValue, value) {
        if (newValue != value) {
          this.showMenu = false;
          this.title = i18n.t("miclive.navigation." + newValue);
          this.back = Object.keys(this.$route.params).length > 0;
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: $font-text, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 300px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}
#container {
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  overflow: hidden;
  padding-bottom: 60px;
  position: relative;
  max-width: 1200px;
  margin-top: 60px;
  margin-bottom: 60px;
}
html {
  background-color: #eeeeee;
}

.back {
  background-size: 20px;
  background-position: center left 10px;
  background-image: url("~@/../public/img/back.svg");
  background-repeat: no-repeat;
  background-color: #fff;
  padding: 10px 10px;
  padding-left: 30px;
  text-align: left;
  margin-bottom: 10px;
  border-radius: 4px;
  width: auto;
  display: inline-block;
  cursor: pointer;
}

.title {
  font-family: $font-title;
  color: $main-color;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.button {
  display: block;
  background-color: $main-color;
  text-align: center;
  color: #fff;
  padding: 15px;
  border-radius: 4px;
  cursor: pointer;
}

.loader {
  background-size: 100px;
  background-position: center;
  //   background-image: url("~@/../public/img/loading.svg");
  background-image: url("~@/../public/img/giphy.gif");
  background-repeat: no-repeat;
  padding: 10px 10px;
  width: 100%;
  height: 250px;
}

.sponsor {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 20px;
  display: block;
}

.banner {
  background: $secondary-color;
  position: fixed;
  width: 100%;
  height: 80px;
  bottom: 50px;
  left: 0;
  z-index: 100;
  overflow: hidden;
  padding: 20px 10px;
  display: flex;
  text-align: left;
  align-items: center;

  .message {
    font-size: 14px;
    margin: 0;
    padding: 0;
    padding-right: 10px;
    width: calc(100% - 115px - 40px);
  }

  .button {
    width: 115px;
    height: 40px;
    line-height: 30px;
    padding: 5px 10px;
  }
  .cancel {
    background-size: 30px;
    background-position: center;
    background-image: url("~@/../public/img/close.svg");
    background-repeat: no-repeat;
    width: 30px;
    height: 30px;
    position: absolute;
    right: 10px;
  }
}

.popup {
  position: fixed;
  background: #fff;
  width: 90%;
  z-index: 1000;
  padding: 20px;
  max-width: 500px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 10%;
  bottom: 10%;
  height: 80%;
  border-radius: 4px;
  overflow-y: auto;

  .message {
    padding: 10px;
  }
  .img {
    width: 100%;
    margin: 0 auto;
    max-width: 250px;
    display: block;
    background-size: 20px;
    background-position: center top;
    background-image: url("~@/../public/img/pwa_ios.gif");
    background-repeat: no-repeat;
    background-size: cover;
    height: 350px;
    margin-bottom: 25px;
  }
  .button {
    max-width: 350px;
    margin: 0 auto;
  }
}
.overlay-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 999;
}
</style>

<style lang="scss">
.tablet {
  #container {
    padding: 30px;
  }
}
.laptop {
  #container {
    padding: 30px;
  }
}
.desktop {
  #container {
    padding: 30px;
  }
}
</style>
